import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Navbar from '@/components/layout/Navbar'

Vue.config.productionTip = false

Vue.component('Navbar', Navbar)

Vue.filter('dateMonthYear', date => {
  const formattedDate = new Date(date);
  if (formattedDate instanceof Date && !isNaN(formattedDate)) {
    const options = {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      timeZone: 'UTC'
    };
    return formattedDate.toLocaleString('pt-BR', options);
  } else {
    return 'Data inválida';
  }
})

Vue.filter('dateTime', date => {
  const formattedDate = new Date(date);
  if (formattedDate instanceof Date && !isNaN(formattedDate)) {
    return formattedDate.toLocaleString('pt-BR');
  } else {
    return 'Data inválida';
  }
})

// Carrega as configurações do sistema salvas no localStorage
store.dispatch('loadConfiguracoes');

const token = sessionStorage.getItem('@SyclusColetor:token') && JSON.parse(sessionStorage.getItem('@SyclusColetor:token'))
const tokens = localStorage.getItem('@SyclusColetor:tokens') && JSON.parse(localStorage.getItem('@SyclusColetor:tokens'))
const licencas = localStorage.getItem('@SyclusColetor:licencas') && JSON.parse(localStorage.getItem('@SyclusColetor:licencas'))

if (token) {
  store.commit('SET_USUARIO_TOKENS', tokens)
  store.commit('SET_USUARIO_LICENCAS', licencas)
  store.dispatch('silentRefresh', token.refresh_token)
    .then(() => {
      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')
    })
} else if (tokens && tokens.length) {
  const [token] = tokens
  
  store.commit('SET_USUARIO_TOKENS', tokens)
  store.commit('SET_USUARIO_LICENCAS', licencas)
  store.dispatch('silentRefresh', token.refresh_token)
    .then(() => {
      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')
    })
} else {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}